module.exports = __webpack_public_path__ + "static/img/decoleft.934d4c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/decoleft.png
// module id = BImu
// module chunks = 46